import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SupportTicket } from '../models/admin.models';
import { ApiResponse, PaginatedResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminTicketsService {
  private baseUrl = `${environment.apiBaseUrl}/admin/tickets`;

  constructor(private http: HttpClient) {}

  getTickets(): Observable<PaginatedResponse<SupportTicket>> {
    return this.http.get<any>(this.baseUrl).pipe(
      map(res => res.data ?? res)
    );
  }

  updateTicketStatus(id: number, status: string): Observable<SupportTicket> {
    return this.http.put<ApiResponse<SupportTicket>>(`${this.baseUrl}/${id}/status`, { status }).pipe(
      map(res => res.data)
    );
  }

  createTicket(data: Partial<SupportTicket>): Observable<SupportTicket> {
    return this.http.post<ApiResponse<SupportTicket>>(this.baseUrl, data).pipe(
      map(res => res.data)
    );
  }
}
